import { Mail, Circle, Home, User, Database, Award, List, Archive } from 'react-feather'


export default [
  {
    id: "home",
    title: "Home",
    icon: <Home size={20} />,
    navLink: "/home",
  },
  {
    id: "dashboard",
    title: "Live",
    icon: <Database size={20} />,
    navLink: "/test_app/Dashboard",
  },
  {
    id: "users",
    title: "User",
    icon: <User size={20} />,
    children: [
      {
        id: "list",
        title: "List",
        icon: <Circle size={12} />,
        navLink: "/user/list",
      },
      {
        id: "view",
        title: "View",
        icon: <Circle size={12} />,
        navLink: "/user/view",
      },
    ],
  },
  {
    id: "activities",
    title: "Activities",
    icon: <List size={20} />,
    navLink: "/activities/list"
    // children: [
    //   {
    //     id: "list",
    //     title: "List",
    //     icon: <Circle size={12} />,
    //   },
    //   {
    //     id: "new_activity",
    //     title: "New",
    //     icon: <Circle size={12} />,
    //     navLink: "/activities/new",
    //   },
    //   {
    //     id: "view_activity",
    //     title: "View",
    //     icon: <Circle size={12} />,
    //     navLink: "/activities/view",
    //   },
    // ],
  },
  {
    id: "anagrafica",
    title: "Anagrafica",
    icon: <Archive size={20} />,
    navLink: '/anagrafica'
  }
];
